import { gql, NetworkStatus, useQuery } from "@apollo/client";
import { shiftStreamClient } from "../../../graphql/client";

export const GET_STREAM = gql`
  query getStream($id: Int!) {
    stream(id: $id) {
      id
      accountId
      state
      shiftId
      adoptedShiftIds
      key
      noAlgo
      slots

      algoRuns {
        id
        createdAt
        matching
        applied
        skipped
        places

        proposed {
          member {
            id
            firstName
            lastName
          }
          score
        }

        rejections {
          members {
            id
            firstName
            lastName
          }
          reason
        }
      }

      account {
        id
        provider
        name
        url
        login
      }

      shift {
        id
        startTime
        endTime
        sourceAccount {
          id
          accountName
        }
        role {
          id
          name
        }
        venue {
          id
          name
        }
        subvenue {
          id
          name
        }
      }
    }
  }
`;

export const useStream = (id: any | null) => {
  const { data, loading, networkStatus, refetch } = useQuery(GET_STREAM, {
    client: shiftStreamClient,
    variables: {
      id: parseInt(`${id}`)
    },
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    skip: id === null,
    onError: error => {
      throw error;
    }
  });

  return {
    loading: loading || networkStatus === NetworkStatus.refetch,
    stream: data?.stream || null,
    refetch
  };
};
